import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { COLORS } from '../../constants';
import { useMsal } from "@azure/msal-react";
import { useAuth } from "../../AuthContext";

const Header: React.FC = () => {

    const { instance, accounts } = useMsal();
    const { isAdmin, isManager } = useAuth();

    const [userName, setUserName] = useState("");

    // 🔵 Get logged user
    useEffect(() => {
        if (accounts.length > 0) {
            const account = accounts[0];

            setUserName(account.name || "");
        }
    }, [accounts]);

    // 🔴 LOGOUT
    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin
        });
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                backgroundColor: COLORS.white,
                color: COLORS.winwireBlue,
                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1100,
            }}
        >
            <Toolbar sx={{ minHeight: '64px !important', display: 'flex', justifyContent: 'space-between' }}>

                {/* LEFT */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontSize: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <img
                                src="/icons/WinEngage.svg"
                                alt="logo"
                                style={{
                                    height: '40px',
                                    width: '160px',
                                    objectFit: 'contain'
                                }}
                            />
                        </Typography>

                        <Typography variant="body2" sx={{
                            color: COLORS.textSecondary,
                            fontSize: '14px',
                            borderLeft: `2px solid ${COLORS.borderGray}`,
                            paddingLeft: 2,
                        }}>
                            Smart Talent Utilization & Accelerator Engine
                        </Typography>
                    </Box>
                </Box>

                {/* RIGHT */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>

                    <Box sx={{ textAlign: 'right' }}>
                        <Typography sx={{ fontWeight: 600 }}>
                            {userName}
                        </Typography>

                        {/*<Typography variant="body2" sx={{ fontSize: '12px' }}>*/}
                        {/*    {email}*/}
                        {/*</Typography>*/}

                        {/*<Typography variant="body2" sx={{ fontSize: '12px', color: '#1976d2' }}>*/}
                        {/*    {empCode}*/}
                        {/*</Typography>*/}

                        {isAdmin && <Typography sx={{ color: 'red', fontSize: 12 }}>Admin</Typography>}
                        {isManager && !isAdmin && <Typography sx={{ color: 'green', fontSize: 12 }}>Manager</Typography>}
                    </Box>

                    <Button
                        variant="contained"
                        color="error"
                        startIcon={<LogoutIcon />}
                        onClick={handleLogout}
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                    >
                        Logout
                    </Button>

                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;